export const isBrowser =
  typeof window !== "undefined" && typeof window.navigator !== "undefined"

export const event = (name: string, data: any) => {
  if (!isBrowser) return
  if (!(window as any).gtag) return
  ;(window as any).gtag("event", name, data)
}
